import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=aea812c0"
import script from "@/views/Logs/Logs.ts?vue&type=script&lang=ts&external"
export * from "@/views/Logs/Logs.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Logs/logs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports